module.exports = __webpack_public_path__ + "static/img/k4_jg_icon_g.png";